export default __webpack_public_path__ + "static/media/smilewebsmall.b0c31a7d.png";